import { Component, OnInit, ViewChild, Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'splitLast' })
export class SplitLastPipe implements PipeTransform {
  transform(value: string, separator: string): string {
    if (value !== null && value !== undefined) {
      let split = value.split(separator);
      if (split.length > 0) {
        return split.shift();
      } else {
        return '';
      }
    }
  }
}



// WEBPACK FOOTER //
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/src/app/core/components/split-last.pipe.ts